import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ab32f7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "liveList border-box p-lr32" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "flex msg" };
const _hoisted_4 = { class: "imgBox m-r24" };
const _hoisted_5 = { alt: "" };
const _hoisted_6 = { class: "time font-24" };
const _hoisted_7 = { class: "info" };
const _hoisted_8 = { class: "title font-32" };
const _hoisted_9 = { class: "text-overflow font-24" };
const _hoisted_10 = { class: "gray-6 font-w500" };
const _hoisted_11 = /*#__PURE__*/ _createTextVNode("  ");
const _hoisted_12 = { class: "gray-9" };
const _hoisted_13 = { class: "flex status font-24" };
const _hoisted_14 = { class: "gray-9" };
const _hoisted_15 = { class: "btn" };
const _hoisted_16 = {
    key: 0,
    class: "living"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 1,
    class: "end font-w500"
};
const _hoisted_19 = {
    key: 0,
    class: "applied gray-9 font-w500"
};
const _hoisted_20 = ["onClick"];
import { hostPath } from '@/public/utils/basePath';
import { appPort, jumpModuleApp, callAppView, goToStudy, getUserId } from '@/widget';
import { liveSubscribe } from '@/api/live';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            default: () => [],
            type: Array
        }
    },
    emits: ['updateList'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const isApp = appPort();
        const toDetail = (item) => {
            if (isApp) {
                jumpModuleApp({
                    typeId: 'live_stream_detail',
                    dataId: item.lessonVideoId
                });
            }
            else {
                location.assign(`${hostPath}/live/broadcast/${item.lessonVideoId}`);
            }
        };
        // 看回看
        const toVideo = (item) => {
            if (isApp) {
                goToStudy('album', item.albumId);
            }
            else {
                callAppView({
                    typeId: 'study_play_detail',
                    type: 'album',
                    dataId: item.albumId
                });
            }
        };
        const userId = getUserId();
        // 预约
        const subscribe = (item, ind) => {
            if (!userId) {
                Toast('请登录后预约');
                return;
            }
            liveSubscribe({ userId, liveId: item.lessonVideoId }).then((res) => {
                if (res.code == 200) {
                    Toast('预约成功');
                    emits('updateList', ind);
                }
            });
        };
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: "white-bg p-lr20 p-tb24 border-box m-b20",
                        key: item.lessonVideoId,
                        onClick: _withModifiers(($event) => (toDetail(item)), ["stop"])
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                                    [_directive_lazy, item.image]
                                ]),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.time), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("h3", _hoisted_8, _toDisplayString(item.albumName), 1),
                                _createElementVNode("p", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.expertName), 1),
                                    _hoisted_11,
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.expertHospital), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.subscribeCountText), 1),
                            _createElementVNode("div", _hoisted_15, [
                                (item.status == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "直播中"))
                                    : (item.status == 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (item.albumId)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "apply font-w500",
                                                    onClick: _withModifiers(($event) => (toVideo(item)), ["stop"])
                                                }, " 看回放 ", 8, _hoisted_17))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_18, "查看详情"))
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            (item.subscribe)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 已预约 "))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "apply font-w500",
                                                    onClick: _withModifiers(($event) => (subscribe(item, key)), ["stop"])
                                                }, " 开播提醒 ", 8, _hoisted_20))
                                        ], 64))
                            ])
                        ])
                    ], 8, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
